export default "__VITE_ASSET__mP$Xdaiz__"